import 'dayjs/locale/fr';
import React, {useCallback, useState} from 'react';
import {Linking, View} from 'react-native';
import {formatDateTo} from '../../../../../common/utils/functions';
import {Validation} from '../../../../../common/utils/validationSouscriptionRetraite';
import url from '../../../../../data/config';
import {TitleLabels} from '../../../../../data/constants/Assurance/assuranceRetraite';
import {useForm} from '../../../../../hooks/AssuranceRetraite/useForm';
import SubmitButtons from '../../../../components/Button/SecondaryButton';
import CheckBoxComponent from '../../../../components/Inputs/Checkbox';
import {InputDatePicker} from '../../../../components/Inputs/InputDatePicker';
import {InputField} from '../../../../components/Inputs/InputField';
import {InputImage} from '../../../../components/Inputs/InputImage';
import {InputPhoneNumber} from '../../../../components/Inputs/InputPhoneNumber';
import Select from '../../../../components/Inputs/Select';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Form = (props: any) => {
  const {data, listAgence, onCancelForm, onSubmitForm, fromSimulation} = props;
  const {handleChange, handleSubmit, values, errors, showErrors, dto} = useForm(
    data,
    Validation,
    handleCancel,
    handleSave,
    listAgence,
  );
  const [isDisable, setIsDisable] = useState(false);

  function handleCancel() {
    onCancelForm();
  }

  function handleSave() {
    if (dto.data.dateNaissanceAssure instanceof Date) {
      dto.data.dateNaissanceAssure = formatDateTo(
        dto.data.dateNaissanceAssure,
        'DD/MM/YYYY',
      );
    }
    dto.data.premierVersement = dto.data.premierVersement.split(' ').join('');

    onSubmitForm(dto.data);
  }

  const showTermsOfUse = useCallback(() => {
    Linking.openURL(url.retraitePdf);
  }, []);

  return (
    <View>
      <View>
        <InputField
          label={TitleLabels.contractant.nomPrenomContractant}
          required
          value={values.nomPrenomContractant}
          name="nomPrenomContractant"
          onChange={handleChange}
          error={errors.nomPrenomContractant}
          showError={showErrors.nomPrenomContractant}
          maxLength={70}
          isEditable={false}
        />

        <InputField
          label={TitleLabels.contractant.dateNaissanceContractant}
          required
          name="dateNaissanceContractant"
          value={values.dateNaissanceContractant}
          onChange={handleChange}
          error={errors.dateNaissanceContractant}
          showError={showErrors.dateNaissanceContractant}
          maxLength={100}
          isEditable={false}
        />
        <InputImage
          label={TitleLabels.contractant.cinContractant}
          required
          value={values.cinContractant}
          name="cinContractant"
          onChange={handleChange}
          error={errors.cinContractant} //cinContractant is not a string
          showError={showErrors.cinContractant}
          maxLength={2}
        />
        <InputPhoneNumber
          label={TitleLabels.contractant.telephoneContractant}
          required
          name="telephoneContractant"
          type="telephone"
          value={values.telephoneContractant}
          onChange={handleChange}
          error={errors.telephoneContractant}
          showError={showErrors.telephoneContractant}
          isEditable={false}
          country={values?.telephoneContractantCountryCode || 'MG'}
        />
        <InputField
          label={TitleLabels.assure.nomPrenomAssure}
          required
          name="nomPrenomAssure"
          value={values.nomPrenomAssure}
          onChange={handleChange}
          error={errors.nomPrenomAssure}
          showError={showErrors.nomPrenomAssure}
          maxLength={70}
        />
        <InputDatePicker
          label={TitleLabels.assure.dateNaissanceAssure}
          required
          value={values.dateNaissanceAssure}
          name="dateNaissanceAssure"
          onChange={handleChange}
          error={errors.dateNaissanceAssure}
          showError={showErrors.dateNaissanceAssure}
          isEditable={!fromSimulation}
        />
        <InputField
          label={TitleLabels.assure.adresseAssure}
          required
          name="adresseAssure"
          value={values.adresseAssure}
          onChange={handleChange}
          error={errors.adresseAssure}
          showError={showErrors.adresseAssure}
          maxLength={50}
        />
        <InputField
          label={TitleLabels.assure.emailAssure}
          required
          name="emailAssure"
          value={values.emailAssure}
          onChange={handleChange}
          error={errors.emailAssure}
          showError={showErrors.emailAssure}
        />
        <InputPhoneNumber
          label={TitleLabels.assure.telephoneAssure}
          required
          type="telephone"
          name="telephoneAssure"
          value={values.telephoneAssure}
          onChange={handleChange}
          error={errors.telephoneAssure}
          showError={showErrors.telephoneAssure}
          country={values?.telephoneAssureCountryCode || 'MG'}
          onChangeCountry={(newCountry: string) =>
            handleChange('telephoneAssureCountryCode', newCountry, true)
          }
        />

        <Select
          data={
            listAgence.length
              ? [
                  {label: 'Choisir Agence', value: ''},
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  ...listAgence.map((element: any) => ({
                    label: element.label,
                    value: element.value,
                  })),
                ]
              : []
          }
          label={TitleLabels.contractant.agence}
          defaultValue={values.agence}
          required={true}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
          onChange={(name: string, data: any, fired: boolean) => {
            handleChange('agence', data, true);
          }}
          value={values.agence}
          error={errors.agence}
          showError={showErrors.agence}
        />

        <InputField
          label={TitleLabels.contractant.premierVersement}
          type="price"
          isEditable={true}
          required
          name="premierVersement"
          value={values.premierVersement}
          onChange={handleChange}
          error={errors.premierVersement}
          showError={showErrors.premierVersement}
        />
        <InputField
          label={TitleLabels.contractant.beneficiaireCasDeces}
          required
          value={values.beneficiaireCasDeces}
          name="beneficiaireCasDeces"
          onChange={handleChange}
          error={errors.beneficiaireCasDeces}
          showError={showErrors.beneficiaireCasDeces}
          maxLength={70}
        />
        <InputImage
          label={TitleLabels.assure.cinAssure}
          required
          value={values.cinAssure}
          name="cinAssure"
          onChange={handleChange}
          error={errors.cinAssure} //cinAssure is not a string
          showError={showErrors.cinAssure}
          maxLength={2}
        />
      </View>
      {/** Submit buttons */}
      <CheckBoxComponent
        changeValue={setIsDisable}
        value={isDisable}
        onPress={() => showTermsOfUse()}
      />
      <View style={{marginTop: -20, marginBottom: 50}}>
        <SubmitButtons
          isDisable={!isDisable}
          cancelAction={handleCancel}
          submitAction={() => {
            handleSubmit();
          }}
          cancelTitle="Annuler"
          submitTitle="Valider"
        />
      </View>
    </View>
  );
};
